import { connect } from "react-redux";
import ErrorBanner from "../../../presentational/common/ErrorBanner";
import getErrorMessage from "./getErrorMessage";

const mapStateToProps = state => ({
  errorMessage: getErrorMessage(state)
});

export default connect(mapStateToProps)(ErrorBanner);
